import { mergeStyles } from "@fluentui/react";

export const colClass = mergeStyles({
    gridColumn: `auto/span 12`,
    justifyContent: 'center',
    textAlign: 'center'
});